import { Button } from "antd";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import "./LandingPage.css";
import { useDispatch, useSelector } from "react-redux";
import { setRelationship } from "../../redux/actions/rbi";
import UcoLogin from "./Login";

const LandingPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const mobileNumber = useSelector((state) => state?.rbi?.number);

  // Extract query parameters
  const queryParams = new URLSearchParams(location.search);
  const emp = queryParams.get("emply");
  const otp = queryParams.get("otp");

  const handleEmployee = (emp) => {
    history.push(`/yajivmar?emply=${emp}`);
    dispatch(setRelationship(""));
  };

  return (
    <>
      {emp === "employee" ? (
        <div className="main-container">
          <UcoLogin />
        </div>
      ) : (
        <div className="main-container">
          <div className="rbi-content">
            <div>
              <h3>
                <span className="text-white">Your</span>{" "}
                <span className="text-orange">Health ,</span>{" "}
                <span className="text-white">Our</span>{" "}
                <span className="text-orange">Priority</span>{" "}
              </h3>
              {/* <h1 className="text-white">Are you an</h1> */}
              <div
                style={{ gap: 10, display: "flex", justifyContent: "center" }}
              >
                <Button
                  className="btn-rounded"
                  onClick={() => handleEmployee("employee")}
                >
                  Employee Login
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LandingPage;
